import React, { FC, ReactHTML } from 'react';
import classNames from 'classnames';
import './Icon.scss';

export const MATERIAL_ICON_CART = 'shopping_cart';
export const MATERIAL_ICON_SORT_BY = 'sort';
export const MATERIAL_ICON_FAVORITE = 'favorite';
export const MATERIAL_ICON_TRASH = 'delete';
export const MATERIAL_ICON_UPLOAD = 'file_upload';
export const MATERIAL_ICON_DOWNLOAD = 'file_download';
export const MATERIAL_ICON_ADD = 'add';
export const MATERIAL_ICON_MAIL = 'mail';
export const MATERIAL_ICON_CLOSE = 'close';
export const MATERIAL_ICON_EDIT = 'mode_edit';
export const MATERIAL_ICON_VIDEO = 'videocam';
export const MATERIAL_ICON_SETTINGS = 'settings';
export const MATERIAL_ICON_MINUS_ONE = 'exposure_neg_1';
export const MATERIAL_ICON_PLUS_ONE = 'exposure_plus_1';
export const MATERIAL_ICON_SEARCH = 'search';
export const MATERIAL_ICON_LANGUAGE = 'language';
export const MATERIAL_ICON_CAMPAIGNS = 'loyalty';
export const MATERIAL_ICON_MARKETING = 'favorite';
export const MATERIAL_ICON_ASSESSMENT = 'assessment';
export const MATERIAL_ICON_CHEVRON_RIGHT = 'chevron_right';
export const MATERIAL_ICON_SET_CAMPAIGN = 'event';
export const MATERIAL_ICON_LINK = 'link';
export const MATERIAL_ICON_LAUNCH = 'launch';
export const MATERIAL_ICON_ARROW_FORWARD = 'arrow_forward';
export const MATERIAL_ICON_EXPAND_LESS = 'expand_less';
export const MATERIAL_ICON_EXPAND_MORE = 'expand_more';
export const MATERIAL_ICON_ARROW_UP = 'arrow_upward';
export const MATERIAL_ICON_ARROW_DOWN = 'arrow_downward';
export const MATERIAL_ICON_ARROW_RIGHT = 'arrow_forward';
export const MATERIAL_ICON_ARROW_LEFT = 'arrow_back';
export const MATERIAL_ICON_MENU = 'menu';

export const MATERIAL_ICONS = [
    MATERIAL_ICON_CART,
    MATERIAL_ICON_TRASH,
    MATERIAL_ICON_UPLOAD,
    MATERIAL_ICON_DOWNLOAD,
    MATERIAL_ICON_ADD,
    MATERIAL_ICON_EDIT,
    MATERIAL_ICON_VIDEO,
    MATERIAL_ICON_SETTINGS,
    MATERIAL_ICON_MINUS_ONE,
    MATERIAL_ICON_PLUS_ONE,
    MATERIAL_ICON_CLOSE,
    MATERIAL_ICON_MAIL,
    MATERIAL_ICON_SEARCH,
    MATERIAL_ICON_LANGUAGE,
    MATERIAL_ICON_CAMPAIGNS,
    MATERIAL_ICON_ASSESSMENT,
    MATERIAL_ICON_MARKETING,
    MATERIAL_ICON_CHEVRON_RIGHT,
    MATERIAL_ICON_SET_CAMPAIGN,
    MATERIAL_ICON_LINK,
    MATERIAL_ICON_ARROW_FORWARD,
    MATERIAL_ICON_EXPAND_LESS,
    MATERIAL_ICON_EXPAND_MORE,
    MATERIAL_ICON_ARROW_UP,
    MATERIAL_ICON_ARROW_DOWN,
    MATERIAL_ICON_SORT_BY,
    MATERIAL_ICON_FAVORITE,
    MATERIAL_ICON_LAUNCH,
    MATERIAL_ICON_MENU,
    MATERIAL_ICON_ARROW_RIGHT,
    MATERIAL_ICON_ARROW_LEFT
];

export const BOLINDA_ICON_BOLINDA_ONLY = 'bolinda_only';
export const BOLINDA_ICON_PDF = 'file_pdf';
export const BOLINDA_ICON_ASSISTANT = 'assistant';
export const BOLINDA_ICON_E_BOOK = 'book-filled';
export const BOLINDA_ICON_E_AUDIOBOOK = 'audiobook-filled';
export const BOLINDA_ICON_QTY_CHANGE = 'qty_change';
export const BOLINDA_ICON_LIBX = 'libx_change';

export const BOLINDA_ICONS = [
    BOLINDA_ICON_BOLINDA_ONLY,
    BOLINDA_ICON_PDF,
    BOLINDA_ICON_ASSISTANT,
    BOLINDA_ICON_E_BOOK,
    BOLINDA_ICON_E_AUDIOBOOK,
    BOLINDA_ICON_QTY_CHANGE,
    BOLINDA_ICON_LIBX
];

export const BUTTON_ICONS = [...MATERIAL_ICONS, ...BOLINDA_ICONS];

const CSS_CLASS_BASED_ICONS = ['copy-product', 'move-product', 'start'];

export function isBolindaIcon(icon: string | undefined | null): boolean {
    if (typeof icon !== 'string') {
        return false;
    }

    return BOLINDA_ICONS.includes(icon);
}

type Props = {
    readonly code: string | undefined;
    readonly className?: string;
    readonly element?: keyof ReactHTML;
};

export const Icon: FC<Props> = ({ code, className, element = 'i', ...props }) => {
    if (code && BOLINDA_ICONS.includes(code)) {
        return React.createElement(element, { ...props, className: classNames('bolinda-icons', className) }, code);
    }

    if (code && CSS_CLASS_BASED_ICONS.includes(code)) {
        return React.createElement(element, {
            ...props,
            className: classNames('bolinda-icons', 'icon', code, className)
        });
    }

    return React.createElement(element, { ...props, className: classNames('material-icons', className) }, code);
};
